/* global attachEvent */

// *******************************************************************************
// 1.0 - Add class to body after some scroll
// *******************************************************************************
function addScrollingClass() {
  const topOffert = document.documentElement.scrollTop || document.body.scrollTop;

  if (topOffert > 50) {
    document.body.classList.add('is-scrolled');
  } else {
    document.body.classList.remove('is-scrolled');
  }
}

// Debounce the function to prevent multiple executions on scroll event
// const debounceScroll = debounce(() => {
//   addScrollingClass();
// }, 100);

window.addEventListener('scroll', addScrollingClass);

let lastScrollTop = 0;

// Ref - https://gist.github.com/cedricbeau/d8dcb3dcf33141bcfda83bae4ae7dc99
window.addEventListener(
  'scroll',
  () => {
    // or window.addEventListener("scroll"....

    const st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > lastScrollTop) {
      document.body.classList.remove('is-scrolled-up');
    } else {
      document.body.classList.add('is-scrolled-up');
    }
    lastScrollTop = st <= 0 ? 0 : st;
  },
  false,
);

// *******************************************************************************
// Open mobile menu
// *******************************************************************************

attachEvent('.mobile-hamburger', 'click', (ev) => {
  // Open menu
  document.body.classList.toggle('is-open-menu');
  const hamburger = ev.target.closest('.mobile-hamburger');

  const isOpen = hamburger.classList.contains('is-open');

  hamburger.classList.toggle('is-open', !isOpen);
  hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

  ev.preventDefault();
});
